<div class="ep">
  <div class="ep-fej">
    <div>
      <h3>Entra-összerendelés</h3>
      <div class="sugo">
        Melyik tanuló melyik címtárbeli fiókkal lép be. A KIR nem ad e-mail címet, a
        tanulói belépés viszont épp arra illeszt – a címtárbeli cím beírása teremti meg
        a kapcsolatot.
        <br>A javaslatot a rendszer adja, de <b>minden sor felülbírálható</b>: egy rossz
        összerendelés azt jelentené, hogy a belépő valaki más adatait látja. Ahol több
        azonos nevű tanuló van, ott <b>nem javaslunk</b> semmit.
      </div>
    </div>
    <ion-button size="small" fill="outline" (click)="betolt()" [disabled]="toltodik">
      <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
    </ion-button>
  </div>

  <!-- címtár -->
  <div class="ep-doboz">
    <div class="ep-sor">
      <b>Címtár</b>
      <input type="text" [(ngModel)]="graphCsoport" placeholder="csoport (nem kötelező)" />
      <ion-button size="small" (click)="graphLekeres()" [disabled]="entraFut">
        <ion-spinner name="crescent" slot="start" *ngIf="entraFut"></ion-spinner>
        <ion-icon slot="start" name="cloud-download-outline" *ngIf="!entraFut"></ion-icon>
        {{ entraFut ? 'Lekérés…' : 'Fiókok lekérése' }}
      </ion-button>
      <span class="halvany" *ngIf="entraForras">{{ entraForras }}</span>
    </div>
    <div class="ep-sor">
      <ion-button size="small" color="tertiary" (click)="potlasProba()" [disabled]="potlasFut">
        <ion-spinner name="crescent" slot="start" *ngIf="potlasFut"></ion-spinner>
        <ion-icon slot="start" name="mail-outline" *ngIf="!potlasFut"></ion-icon>
        Hiányzó címek kitöltése – összevetés
      </ion-button>
      <span class="halvany">
        Minden címtelen tanulóra: oktatási azonosító, vagy pontos és egyértelmű név
        (azonos neveknél az osztály dönt). Előbb csak megmutatja, mit írna.
      </span>
    </div>
    <div class="ep-hiba" *ngIf="hiba">{{ hiba }}</div>
    <div class="sugo" *ngIf="!entraSorok.length && !entraFut">
      A javaslatokhoz előbb le kell kérni a címtár fiókjait.
    </div>
  </div>

  <!-- tömeges kitöltés eredménye -->
  <div class="ep-doboz" *ngIf="potlas">
    <div class="ep-sor">
      <b>{{ potlas.probafutas ? 'Összevetés (még nem írt)' : 'Kitöltve' }}:</b>
      <span>{{ potlas.cimtelen_db }} címtelen tanuló,
        {{ potlas.irhato_db }} kitölthető<span *ngIf="!potlas.probafutas">, {{ potlas.irt }} beírva</span>,
        {{ potlas.kimaradt?.length || 0 }} kimarad ({{ potlas.entra_db }} címtárfiók).</span>
      <ion-button size="small" color="success" *ngIf="potlas.probafutas && potlas.irhato_db"
                  (click)="potlasIras()" [disabled]="potlasFut">
        <ion-icon slot="start" name="save-outline"></ion-icon>Kitöltés ({{ potlas.irhato_db }})
      </ion-button>
      <ion-button size="small" fill="clear" color="medium" (click)="potlas = null">bezár</ion-button>
    </div>
    <div class="ep-burok" *ngIf="potlas.tetelek?.length">
      <table class="ep-tabla">
        <thead><tr><th>Név</th><th>Osztály</th><th>E-mail cím</th><th>Címtárbeli név</th><th>Alap</th></tr></thead>
        <tbody>
          <tr *ngFor="let t of potlas.tetelek">
            <td>{{ t.nev }}</td><td>{{ t.osztaly }}</td><td>{{ t.email }}</td>
            <td class="halvany">{{ t.entra_nev }}</td><td class="halvany">{{ t.alap }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <details *ngIf="potlas.kimaradt?.length">
      <summary>Kimaradt tanulók ({{ potlas.kimaradt.length }}) – ezeket soronként, lent lehet beállítani</summary>
      <div *ngFor="let k of potlas.kimaradt" class="halvany">
        {{ k.nev }} ({{ k.azonosito }}){{ k.email ? ' – ' + k.email : '' }}: {{ k.ok }}
      </div>
    </details>
  </div>

  <!-- szűrők -->
  <div class="ep-sor">
    <b class="ep-db">{{ tanulok.length }} tanuló</b>
    <input type="text" [(ngModel)]="szuro" placeholder="keresés név vagy azonosító szerint" />
    <label><input type="checkbox" [(ngModel)]="csakHianyzo" /> csak akinek még nincs</label>
    <ion-button size="small" fill="outline" (click)="javaslatokatElfogad()"
                [disabled]="!entraSorok.length">Javaslatok elfogadása</ion-button>
    <ion-button size="small" color="success" (click)="ment()"
                [disabled]="mentesFut || !valtozasok.length">
      <ion-icon slot="start" name="save-outline"></ion-icon>
      Mentés ({{ valtozasok.length }})
    </ion-button>
  </div>

  <div class="ep-allapot" *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner><span>Betöltés…</span></div>
  <div class="ep-ures" *ngIf="!toltodik && !lista.length">
    Nincs megjeleníthető tanuló ezzel a szűréssel.
  </div>
  <div class="ep-hiba" *ngIf="utkozok">
    {{ utkozok }} tanulónál <b>ugyanaz a cím szerepel</b>. Egy címhez egy tanuló tartozhat –
    különben a belépő kiszámíthatatlanul valaki más adatait kapná. A mentés ezeket kihagyja.
  </div>

  <div class="ep-burok" *ngIf="lista.length">
    <table class="ep-tabla">
      <thead><tr>
        <th>Név</th><th>Oktatási azonosító</th><th>Osztály</th>
        <th>E-mail cím a címtárból</th><th>Alap</th><th></th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let f of lista" [class.valtozott]="valtozott(f)" [class.utkozo]="utkozik(f)">
          <td>{{ f.nev }}</td>
          <td class="halvany">{{ f.azonosito }}</td>
          <td>{{ f.osztaly_nev }}</td>
          <td>
            <!-- Szabadon írható ÉS listából választható: a címtárban nem mindig az a
                 név szerepel, amit a javaslat talál, és ilyenkor kézzel kell megadni. -->
            <input class="ep-mezo" type="text" list="entraFiokok"
                   [value]="ertek(f)" (change)="allit(f, $any($event.target).value)"
                   placeholder="pl. vezeteknev.keresztnev@iskola.hu" />
          </td>
          <td class="halvany">{{ alap(f) }}</td>
          <td>
            <ion-button size="small" fill="clear" *ngIf="f.javaslat && !ertek(f)"
                        (click)="allit(f, f.javaslat, f.javaslatAlap)">javaslat</ion-button>
            <ion-button size="small" fill="clear" color="medium" *ngIf="valtozott(f)"
                        (click)="visszavon(f)">vissza</ion-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <datalist id="entraFiokok">
    <option *ngFor="let e of entraSorok" [value]="belepesiNev(e)">{{ entraCimke(e) }}</option>
  </datalist>

  <div class="ep-doboz" *ngIf="eredmeny">
    <b>Mentve:</b> {{ eredmeny.tanulo }} tanuló
    <span *ngIf="eredmeny.valtozatlan" class="halvany">({{ eredmeny.valtozatlan }} változatlan)</span>
    <div class="ep-hiba" *ngIf="eredmeny.hibak?.length">
      <div *ngFor="let h of eredmeny.hibak">{{ h.azonosito }}: {{ h.hiba }}</div>
    </div>
  </div>

  <small class="sugo">
    A cím a tanuló <b>e-mail mezőjébe</b> kerül – erre illeszt a belépés (az oktatási
    azonosító mellett). Egy címhez <b>egy tanuló</b> tartozhat: az ütköző sorokat a mentés
    kihagyja és nevesítve visszajelzi. Üres mezővel az összerendelés visszavonható – ilyenkor
    az adott tanuló nem tud belépni.
    <br><b>Dolgozóra ez a képernyő nem vonatkozik:</b> ott az azonosító a belépési kulcs,
    azon nincs mit összerendelni.
  </small>
</div>
